import ChapteredVideo from "./ChapteredVideo";
import OverlayManager from "./OverlayManager";

import {
  isOrientationLandscape,
  isMobile,
  showOrientationAlert,
} from "./utils";

// add prompt if needed
// NOTE: these need to appear outside the dynamic import
// since the DOMContentLoaded event fires before the import completes
const addOrientationOverlay = () => {
  if (!isOrientationLandscape() && isMobile()) {
    showOrientationAlert(true);
    document.querySelector(".video-timeline").style.display = "none";
    document.querySelector(".overlay-manager").style.display = "none";
  } else {
    showOrientationAlert(false);
    document.querySelector(".video-timeline").style.display = "flex";
    document.querySelector(".overlay-manager").style.display = "flex";
  }
};

window.addEventListener("DOMContentLoaded", () => {
  addOrientationOverlay();
});

window.addEventListener("resize", (e) => {
  addOrientationOverlay();
});

// dynamic import so that we can provide the config file through an
// environmental variable
import(process.env.CONFIG_FILE).then(
  ({ title, link, chapters, deploymentUrl }) => {
    const videoChapters = new ChapteredVideo({
      chapters,
      appendTo: document.querySelector(".video-timeline"),
      onChapterChange: function () {
        const id = this.id;
        // TODO this logic should live inside the ChapteredVideo component
        document.querySelectorAll(".chapter-content-title").forEach((elm) => {
          elm.style["color"] = `grey`;
        });
      },
      onSceneChange: function () {
        const id = this.id;
      },
    });

    const overlayManager = new OverlayManager({
      appendTo: document.querySelector(".overlay-manager"),
      onVideoEnd: (id) => {
        videoChapters.updateSelectedChapter(id);
      },
      startTimes: chapters.map((c) => c.startTime),
      title,
      videoUrl: link,
      deploymentUrl,
    });

    // further operations to be done on chapter change // ie. to video manager
    const chapterButtons = document.querySelectorAll(".chapter-index__button");
    chapterButtons.forEach((e) =>
      e.addEventListener("click", function () {
        const id = parseInt(this.dataset.chapter);
        overlayManager.player.setCurrentTime(chapters[id].startTime);
        overlayManager.updateChapter(id);
      })
    );

    const sceneButtons = document.querySelectorAll(".chapter-index__content");
    sceneButtons.forEach((e) =>
      e.addEventListener("click", function () {
        // var id = parseInt(this.id.split("_")[2]);
        let id = parseInt(this.dataset.chapter);
        let subId = parseInt(this.dataset.section);

        // TODO this logic should live inside the ChapteredVideo component
        document.querySelectorAll(".chapter-content-title").forEach((elm) => {
          elm.style["color"] = `grey`;
        });
        e.querySelectorAll(".chapter-content-title").forEach((elm) => {
          elm.style["color"] = `rgb(238, 66, 56)`;
        });

        // @todo add pop up content manipulation
        overlayManager.updateOverlayContent(chapters[id].content[subId]);
      })
    );
  }
);
